import { useQueryHelper } from '@anytag/shared-hooks';
import { useTiktokTagPostDetailsQuery } from '@anytag/graphql';
import { PostModal, usePostModalContext } from '../shared';

export interface TemplateProps {
  className?: string;
}

export const Template = ({ className }: TemplateProps) => {
  const { t, enqueueSnackbar } = useQueryHelper();
  const { closeModal, selectedPostId } = usePostModalContext();
  const { data, loading } = useTiktokTagPostDetailsQuery({
    skip: !selectedPostId,
    variables: { postId: Number(selectedPostId) },
    onError: (error) => {
      closeModal?.();
      enqueueSnackbar(t(error.message), { variant: 'error' });
    }
  });

  const details = data?.tiktokTagPostDetails;

  return (
    <PostModal.DetailsTemplate
      loading={loading}
      className={className}
      data={
        details
          ? {
              socialMedia: 'TIKTOK',
              postUrl: details?.postUrl,
              postDate: details?.postDate,
              caption: details?.content || '',
              images: details?.thumbnail ? [details.thumbnail] : [],
              statistics: {
                likes: details?.likes,
                views: details?.views,
                comments: details?.comments,
                saves: details?.saves,
                shares: details?.shares
              },
              info: { name: null, avatar: null }
            }
          : undefined
      }
    />
  );
};
